import React, { useContext, useEffect, useState } from "react";
import NetwalaModal from "../Items/Modal/Index";
import IPTVWhiteIcon from "./../../assets/svgs/IconsWhite/IPTVWhite.svg";
import IPTVIcon from "./../../assets/svgs/IPTVIcon.svg";
import RemoveIcon from "./../../assets/svgs/RemoveIcon.svg";
import PlusIcon from "./../../assets/svgs/IconsWhite/PlusIcon.svg";
import EditIconYellow from "./../../assets/svgs/EditIconYellow.svg";

import { Col, Form, Input, Row, Typography } from "antd";
import "./styles/RequestIPTVModal.css";
import NetwalaButton from "../Items/Button/Index";
import { ButtonProps } from "../../helpers/constants";
import RemoveConfirmationUtil from "./RemoveConfirmationUtil";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import ThreeDotsLoader from "../Items/Loaders/Threedots";
import BalanceContext from "../../context/BalanceContext";
const IPTVModal: React.FC<IPTVModalProps> = ({
  show,
  handleClose,
  connection,
  settings,
}) => {
  const { value, setValue } = useContext(BalanceContext);

  const [isIPTVAdded, setIsIPTVAdded] = useState(false);
  const [iptvSubscription, setIptvSubscription] = useState<null | any>(null);
  const [isRemovedClicked, setIsRemoveClicked] = useState(false);
  const { openNotification, contextHolder } = useMultiNotification();
  const [isAmountEditEnabled, setIsAmountEditEnabled] =
    useState<boolean>(false);
  const [invoiceAmount, setInvoiceAmount] = useState<number>(0);
  const [
    postSubscribeIPTVApi,
    subscribeIPTVApiResponse,
    subscribeIPTVApiError,
    subscribeIPTVApiLoading,
    subscribeIPTVApiMessage,
    subscribeIPTVApiErrorCount,
  ] = useAxiosPost<RequestIPTVSubscriptionApiProp>(
    "connections/requestIPTVSubscription",
    true
  );
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<IPTVByISPAndCompanyApiProp>(
    "iptv/getIPTVPriceByCompanyAndISP"
  );
  const [
    getIPTVSubscription,
    subscriptionApiResponse,
    subscriptionApiError,
    subscriptionApiLoading,
    subscriptionApiMessage,
    subscriptionApiErrorCount,
  ] = useAxiosPost<IPTVSubscriptionForConnectionApiProp>(
    "connections/getIPTVDetailsByConnection"
  );
  const [
    requestToRemoveSubscription,
    removeSubscriptionApiResponse,
    removeSubscriptionApiError,
    removeSubscriptionApiLoading,
    removeSubscriptionApiMessage,
    removeSubscriptionApiErrorCount,
  ] = useAxiosPost<IPTVSubscriptionForConnectionApiProp>(
    "connections/requestToRemoveIPTVSubscription"
  );
  const [iptv, setIptv] = useState<Package | null>(null);
  useEffect(() => {
    postApiData({ intPkIspID: Number(connection.intPkIspID) });
    getIPTVSubscription({ intPkConnectionID: connection.intPkConnectionID });
  }, []);
  useEffect(() => {
    if (subscriptionApiResponse !== null) {
      const data: any = subscriptionApiResponse.responseData;
      if (!data) {
        setIptvSubscription(null);
        setIsIPTVAdded(false);
      } else {
        setIptvSubscription(data);
        setIsIPTVAdded(true);
      }
    }
  }, [subscriptionApiResponse]);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      if (data) {
        setIptv(data);
        setInvoiceAmount(data.salePrice);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (subscribeIPTVApiError !== null && subscribeIPTVApiErrorCount !== 0) {
      openNotification(`error`, "Operation Failed", subscribeIPTVApiError);
    }
  }, [subscribeIPTVApiError, subscribeIPTVApiErrorCount]);
  useEffect(() => {
    if (subscribeIPTVApiResponse !== null) {
      const { message } = subscribeIPTVApiResponse;
      if (message) {
        setValue(value + 1);

        openNotification(`success`, "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2000);
      }
    }
  }, [subscribeIPTVApiResponse]);
  const onFinish = (values: any) => {
    console.log("Clicked");
    if (!iptv) {
      openNotification(
        `error`,
        "Operation Failed",
        `Error While Subscribing , Please Try again`
      );
      return;
    }
    const { amount } = values;
    const _amount = isAmountEditEnabled === true ? amount : invoiceAmount;
    const dataToSend: RequestIPTVSubscriptionApiProp = {
      intPkConnectionID: connection.intPkConnectionID,
      intPkIspID: Number(connection.intPkIspID),
      amountReceived: _amount,
    };
    postSubscribeIPTVApi(dataToSend);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const handleAddNewService = () => {};
  const removeConfirmation = (confirm: boolean) => {
    if (confirm === false) {
      setIsRemoveClicked(false);
      return;
    }
    //we'll call the remove api here and get the result . once done then we'll do the handleClose
    requestToRemoveSubscription({
      intPkConnectionID: connection.intPkConnectionID,
    });
  };

  useEffect(() => {
    if (removeSubscriptionApiResponse !== null) {
      const { message } = removeSubscriptionApiResponse;
      if (message) {
        openNotification(`success`, "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2000);
      }
    }
  }, [removeSubscriptionApiResponse]);

  useEffect(() => {
    if (
      removeSubscriptionApiError !== null &&
      removeSubscriptionApiErrorCount !== 0
    ) {
      openNotification(`error`, "Operation Failed", removeSubscriptionApiError);
    }
  }, [removeSubscriptionApiError, removeSubscriptionApiErrorCount]);
  return (
    <>
      <NetwalaModal
        title="IPTV"
        titleImage={IPTVWhiteIcon}
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => handleClose(false)}
      >
        {contextHolder}

        {isRemovedClicked === true ? (
          <RemoveConfirmationUtil
            confirmationButton={removeConfirmation}
            message={` Are you sure you want to remove IPTV Service?`}
            isLoading={removeSubscriptionApiLoading}
          />
        ) : (
          <Row>
            <Col span={24} className="iptv-modal-connection-details-container">
              <Typography className="user-full-name">
                {connection.firstName + " " + connection.lastName}
              </Typography>
              <Typography className="user-phone">
                {connection.username}
              </Typography>
              <Typography className="user-address">
                {connection.address},{connection.areaName}
              </Typography>
            </Col>
            <Col span={24} className="iptv-modal-package-details">
              <div className="iptv-modal-isp-details-container">
                <img style={{ maxHeight: "50px" }} src={connection.url} />
                <Typography className="isp-name">
                  {connection.ISPName}
                </Typography>
              </div>
              <Typography className="package-name">
                {connection.packageName}
              </Typography>
            </Col>
            {apiLoading === true || subscriptionApiLoading === true ? (
              <ThreeDotsLoader />
            ) : (
              <>
                {isIPTVAdded === true ? (
                  <>
                    <Col span={24}>
                      <div className="iptv-subscribed-container">
                        <div className="iptv-subscription-details">
                          <img src={IPTVIcon} />
                          <Typography className="iptv-subscription-label">
                            IPTV Added
                          </Typography>
                        </div>
                        <img
                          onClick={(e) => {
                            setIsRemoveClicked(true);
                          }}
                          src={RemoveIcon}
                          className="cursor-pointer"
                        />
                      </div>
                    </Col>
                  </>
                ) : (
                  <>
                    {connection.isIPTVRequested ? (
                      <>
                        <Col
                          span={24}
                          className="iptv-service-details-container"
                        >
                          <Typography className="details-message">
                            IPTV Service Request Already Made
                          </Typography>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col
                          span={24}
                          className="iptv-service-details-container"
                        >
                          <Typography className="details-message">
                            No IPTV Services on your connection
                          </Typography>
                          <div className="price-container">
                            <Typography className="price-label">
                              Additional Price{" "}
                            </Typography>
                          </div>
                        </Col>
                        <Col
                          span={24}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: "40px",
                          }}
                          className="iptv-service-details-container"
                        >
                          {iptv && (
                            <Form
                              requiredMark={false}
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                              layout="vertical"
                              onFinish={onFinish}
                              onFinishFailed={onFinishFailed}
                              name="requestIpTVModalForm"
                              initialValues={{
                                amount: invoiceAmount,
                              }}
                            >
                              {isAmountEditEnabled === true && (
                                <Form.Item
                                  name="amount"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please Enter Amount",
                                    },
                                    {
                                      validator: (_, value) =>
                                        value > -1
                                          ? Promise.resolve()
                                          : Promise.reject(
                                              new Error(
                                                "Amount must be greater than 0"
                                              )
                                            ),
                                    },
                                    {
                                      validator: (_, value) =>
                                        value > iptv?.salePrice
                                          ? Promise.reject(
                                              new Error(
                                                "Amount must not be greater than total Amount"
                                              )
                                            )
                                          : Promise.resolve(),
                                    },
                                  ]}
                                  label={
                                    <span
                                      style={{
                                        color: "#DE1818",
                                        fontSize: "14px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      Invoice Amount
                                    </span>
                                  }
                                >
                                  <Input
                                    value={invoiceAmount}
                                    onChange={(e) => {
                                      setInvoiceAmount(Number(e.target.value));
                                    }}
                                    type="number"
                                    className="user-input-general-height"
                                    placeholder="10"
                                  />
                                </Form.Item>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginTop: "10px",
                                  marginBottom: "10px",
                                  gap: "15px",
                                }}
                              >
                                <Typography
                                  style={{
                                    color: "#359528",
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {invoiceAmount}/-
                                </Typography>
                                {settings.isInvoiceAmountEditable === 1 && (
                                  <img
                                    className="cursor-pointer"
                                    src={EditIconYellow}
                                    onClick={(e) => {
                                      setIsAmountEditEnabled(true);
                                    }}
                                  />
                                )}
                              </div>
                              <Form.Item>
                                <NetwalaButton
                                  backgroundColor={
                                    ButtonProps.background.YELLOW
                                  }
                                  height={ButtonProps.height.STANDARD}
                                  width={ButtonProps.width.STANDARD}
                                  textColor={ButtonProps.color.STANDARD}
                                  onClick={() => handleAddNewService()}
                                  text="Request IPTV"
                                  htmlType="submit"
                                  icon={<img src={PlusIcon} />}
                                  borderColor="#FFA726"
                                  disabled={subscribeIPTVApiLoading}
                                />
                              </Form.Item>
                            </Form>
                          )}
                        </Col>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </Row>
        )}
      </NetwalaModal>
    </>
  );
};

export default IPTVModal;
